module.exports = __webpack_public_path__ + "img/30.2.TN.3c4787be.png";